/**
 * Soft accent glow that follows the cursor. Disabled on touch-primary devices
 * since hover positioning is meaningless there.
 */
export function initCursorGlow() {
  const isTouch = window.matchMedia?.('(hover: none)').matches;
  if (isTouch) return;

  const glow = document.createElement('div');
  glow.className = 'cursor-glow';
  glow.style.cssText = [
    'position: fixed',
    'pointer-events: none',
    'z-index: 9998',
    'width: 300px',
    'height: 300px',
    'border-radius: 50%',
    'background: radial-gradient(circle, rgba(0, 245, 255, 0.04) 0%, transparent 70%)',
    'transform: translate(-50%, -50%)',
    'transition: left 0.15s ease, top 0.15s ease',
    'left: -100%',
    'top: -100%',
  ].join(';');
  document.body.appendChild(glow);

  // Coalesce mousemove events to one style write per animation frame.
  // A raw mousemove handler can fire 100+ times/sec; rAF caps it at the
  // display refresh rate and avoids layout thrash.
  let x = 0;
  let y = 0;
  let queued = false;

  document.addEventListener('mousemove', (e) => {
    x = e.clientX;
    y = e.clientY;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      glow.style.left = `${x}px`;
      glow.style.top  = `${y}px`;
      queued = false;
    });
  }, { passive: true });
}
